import { useMediaQuery } from "@crehana/react-hooks";
import { Container } from "@crehana/ui";
import DesktopLayoutSkeleton from "./layout/DesktopLayoutSkeleton";
import MobileLayoutSkeleton from "./layout/MobileLayoutSkeleton";
import TabletLayoutSkeleton from "./layout/TabletLayoutSkeleton";
import { jsx as _jsx } from "react/jsx-runtime";
var PayGLayoutSkeleton = function PayGLayoutSkeleton(_ref) {
  var isDark = _ref.isDark,
    dataTestId = _ref['data-testid'],
    containerType = _ref.containerType;
  var _useMediaQuery = useMediaQuery('sm'),
    isSm = _useMediaQuery.matches;
  var _useMediaQuery2 = useMediaQuery('md'),
    isMd = _useMediaQuery2.matches;
  var renderSkeleton = function renderSkeleton(testId) {
    if (isMd) {
      return /*#__PURE__*/_jsx(DesktopLayoutSkeleton, {
        "data-testid": testId,
        isDark: isDark
      });
    }
    if (isSm) {
      return /*#__PURE__*/_jsx(TabletLayoutSkeleton, {
        "data-testid": testId,
        isDark: isDark
      });
    }
    return /*#__PURE__*/_jsx(MobileLayoutSkeleton, {
      "data-testid": testId,
      isDark: isDark
    });
  };
  return containerType ? /*#__PURE__*/_jsx(Container, {
    type: containerType,
    "data-testid": dataTestId,
    children: renderSkeleton()
  }) : renderSkeleton(dataTestId);
};
export default PayGLayoutSkeleton;